import { render } from "./checkboxInput.vue?vue&type=template&id=b92d179c&scoped=true&ts=true"
import script from "./checkboxInput.vue?vue&type=script&lang=ts"
export * from "./checkboxInput.vue?vue&type=script&lang=ts"

import "./checkboxInput.vue?vue&type=style&index=0&id=b92d179c&lang=less&scoped=true"

import exportComponent from "D:\\Website desing\\kkiokio\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b92d179c"]])

export default __exports__